import axios from 'axios';
import { getErrorMessage, showErrorToast } from '../utils/toast';

export const FETCH_PRINCIPAL_REQUEST = 'FETCH_PRINCIPAL_REQUEST' as const;
export const FETCH_PRINCIPAL_SUCCESS = 'FETCH_PRINCIPAL_SUCCESS' as const;
export const FETCH_PRINCIPAL_FAILURE = 'FETCH_PRINCIPAL_FAILURE' as const;

export const FETCH_PRINCIPAL_WITH_ID_REQUEST = 'FETCH_PRINCIPAL_WITH_ID_REQUEST' as const;
export const FETCH_PRINCIPAL_WITH_ID_SUCCESS = 'FETCH_PRINCIPAL_WITH_ID_SUCCESS' as const;
export const FETCH_PRINCIPAL_WITH_ID_FAILURE = 'FETCH_PRINCIPAL_WITH_ID_FAILURE' as const;

export const CLEAR_STORE = 'CLEAR_STORE' as const;

export const clearStoreAction = () => ({
  type: CLEAR_STORE,
});

export const fetchPrincipals = () => async (dispatch: any) => {
  dispatch({ type: FETCH_PRINCIPAL_REQUEST });
  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/principals/?page=1&limit=1000`,
      timeout: 10000000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    });

    dispatch({ type: FETCH_PRINCIPAL_SUCCESS, payload: response.data });
  } catch (error: any) {
    const msg = getErrorMessage(error, 'Failed to load principals');
    dispatch({ type: FETCH_PRINCIPAL_FAILURE, error: msg });
    showErrorToast(msg);
  }
};

export const fetchPrincipalWithId = (principalId: number | string) => async (dispatch: any) => {
  dispatch({ type: FETCH_PRINCIPAL_WITH_ID_REQUEST });

  try {
    const token = localStorage.getItem('accessToken');
    const response = await axios.request({
      baseURL: `${window.env.API_URL}/v1/programs/principals/${principalId}`,
      timeout: 10000000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'GET',
    });

    dispatch({ type: FETCH_PRINCIPAL_WITH_ID_SUCCESS, payload: response.data.principal });
  } catch (error: any) {
    const msg = getErrorMessage(error, 'Failed to load principal details');
    dispatch({ type: FETCH_PRINCIPAL_WITH_ID_FAILURE, error: msg });
    showErrorToast(msg);
  }
};

